import { render, staticRenderFns } from "./Etablissement.vue?vue&type=template&id=7fd52db0&scoped=true"
import script from "./Etablissement.vue?vue&type=script&lang=js"
export * from "./Etablissement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd52db0",
  null
  
)

export default component.exports